// Статус Анны для пилюли в сайдбаре (задача D4; пилюля — D5): вердикт, ступень, каналы, бюджет.
// Опрос раз в 60 с; поток событий (D3/D5) кладёт свежий статус в тот же ключ между опросами.
import { StatusSchema } from '@contract/index.js';
import { queryOptions } from '@tanstack/react-query';
import { apiGet } from '../client';
import { qk } from '../keys';

export const STATUS_PATH = '/api/v1/status';

export const statusQuery = queryOptions({
  queryKey: qk.status,
  queryFn: ({ signal }) => apiGet(STATUS_PATH, StatusSchema, { signal }),
  refetchInterval: 60_000,
});
